



























































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import BaseView from '~/components/BaseView';
import IRIInfo from '~/components/iri-content/iri-info.vue';

@Component<IriModal>({
    components: {
        IRIInfo,
    },
    icons: {
        faTimes,
    },
})
export default class IriModal extends BaseView {
    @Prop()
    isShowDialogue!: boolean;

    handleClose() {
        this.$emit('close');
    }
}
